/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Defines sources that can manage the workload. API - workload is managed by Cast API. Annotations - workload is managed by annotations.
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1ManagedBy = {
    API: 'API',
    ANNOTATIONS: 'ANNOTATIONS'
} as const;

export type WorkloadoptimizationV1ManagedBy = typeof WorkloadoptimizationV1ManagedBy[keyof typeof WorkloadoptimizationV1ManagedBy];



